/**
 * @generated SignedSource<<f51ab539adaea82dcae602cb30c0179e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFavoritesProvider_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FolderWrapperWrapper_viewer" | "HeartWrapper_viewer" | "PortfolioFolderWrapper_viewer">;
  readonly " $fragmentType": "SharedFavoritesProvider_viewer";
};
export type SharedFavoritesProvider_viewer$key = {
  readonly " $data"?: SharedFavoritesProvider_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFavoritesProvider_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "selectedItemIds",
  "variableName": "selectedItemIds"
},
v1 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v2 = [
  (v0/*: any*/),
  {
    "kind": "Variable",
    "name": "shouldFillInFolder",
    "variableName": "shouldFillInFolder"
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadPortfolioData"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "selectedItemIds"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "shouldFillInFolder"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFavoritesProvider_viewer",
  "selections": [
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "FolderWrapperWrapper_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "HeartWrapper_viewer"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "PortfolioFolderWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f3d7c56a2f194d3108b8366801428449";

export default node;
